import { ClientEvents } from 'common/events/ClientEvents';
import React, { useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from 'src/shared/design-system/Modal';
import { useTracker } from 'src/shared/hooks/useTracker';
import { StepByStepWithDotIndicator } from 'src/step-by-step/StepByStepWithDotIndicator';
import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';
import { ChooseADeliveryDayStep, ChooseYourDishesStep, ExploreLocalShefsStep } from './EducationStep';

const StyledModal = styled(Modal)`
  width: 400px;

  & > ${ModalHeader} {
    font-size: 22px;
    line-height: 28px;
    color: ${Colors.RADISH};
  }
`;

const CloseButton: React.FC<React.PropsWithChildren<{ onClick: () => void }>> = ({ onClick, children }) => (
  <div className='h-6 cursor-pointer text-right text-body-600 text-neutral-300' onClick={onClick}>
    {children}
  </div>
);

interface INewUserEducationModalProps {
  isShowing: boolean;
  onHide: () => void;
}

export const NewUserEducationModal: React.FC<INewUserEducationModalProps> = ({ isShowing, onHide }) => {
  const tracker = useTracker();

  useEffect(() => {
    if (isShowing) {
      tracker.track(ClientEvents.NEW_USER_EDUCATION_VIEW, {});
    }
  }, [isShowing, tracker]);

  return (
    <StyledModal isShowing={isShowing} onClose={onHide}>
      <ModalHeader>
        How Shef Works
        <CloseButton onClick={onHide}>Close</CloseButton>
      </ModalHeader>
      <ModalBody>
        <StepByStepWithDotIndicator onComplete={onHide}>
          <ExploreLocalShefsStep />
          <ChooseADeliveryDayStep />
          <ChooseYourDishesStep />
        </StepByStepWithDotIndicator>
      </ModalBody>
    </StyledModal>
  );
};
